import './loadingComponent.scss'
const LoadingComponent = ({text}) =>{
    return(
        <div className="loading-container">
          <div className="spinner"></div>
          <span>{text}</span>
        </div>
    )
}
export default LoadingComponent;